/**
 * Unsplash trail / summit atmosphere for the Hiking app landing.
 * Keep URLs stable; swap only if assets move.
 */
export const HIKING_LANDING_IMAGES = {
  ridgeBackground:
    'https://images.unsplash.com/photo-1551632811-561732d1e306?auto=format&fit=crop&w=1600&q=80',
  forestBackground:
    'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?auto=format&fit=crop&w=1600&q=80',
};
